module.exports = __webpack_public_path__ + "static/media/bg_page-19.98ae786d.png";